'use client';

import dynamic from 'next/dynamic';

import * as animationData from './transition.json';

// Dynamically import lottie-react to avoid server-side issues
const Lottie = dynamic(() => import('lottie-react'), {ssr: false});

export const LottieLoading = () => {
	return <Lottie animationData={animationData} />;
};
